export const setupIntercom = (appId, language = 'en') => {
  const intercomSettings = {
    app_id: appId,
    language_override: language,
  };
  window.Intercom('shutdown');
  window.Intercom('boot', intercomSettings);
};
